import React from 'react';
import clsx from 'clsx';
import { Icon } from '../../icon';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Slice Icon Component
 * @param iconSize {IconSize} Size for icon
 * @param iconName {IconName} Name for icon
 * @param iconColor {IconColor} Custom color for icon
 * @param children {ReactNode}
 * ------------------ WEB PROPERTIES ---------------------
 * @param className {string} Additionnal CSS Classes
 */
const SliceIcon = ({ className, iconSize, iconName, iconColor, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('slice-icon', className));
    return (React.createElement("div", { className: classes, ...others },
        React.createElement(Icon, { name: iconName, ...(iconColor && { color: iconColor }), ...(iconSize && { size: iconSize }) })));
};
export default SliceIcon;
//# sourceMappingURL=SliceIcon.js.map